{
	"cancelOrder": {
		"title": "Cancel order",
		"ticker": "Ticker",
		"option": "Option",
		"operation": "Operation",
		"quantity": "Quantity",
		"price": "Price",
		"orderType": "Order Type",
		"executed": "Executed",
		"orderDuration": "Time in Force",
		"limitPrice": "Limit Price",
		"sharePerContract": "Share per Contract",
		"sum": "Price",
		"no": "No",
		"yes": "Yes",
		"side": {
			"buy": "Buy",
			"sell": "Sell",
			"sell_short": "Sell Short"
		},
		"types": {
			"market": "Market",
			"limit": "Limit",
			"stop": "Stop",
			"stop_limit": "Stop Limit",
			"trailing_stop": "Trailing Stop"
		},
		"terms": {
			"day": "DAY",
			"gtc": "GTC",
			"opg": "OPG",
			"cls": "CLS",
			"ioc": "IOC",
			"dayPlus": "DAY+"
		},
		"attributes": {
			"stop_loss": "Stop Loss",
			"take_profit": "Take Profit"
		},
		"orderSuccessfullyCanceled": "The order was successfully cancelled!",
		"couldn'tCancelOrder": "Couldn't cancel the order."
	}
}
